export interface ModalFrameOptions {
  size: string;
  variant: string;
  theme: string;
}

/** Constructs the stable overlay and card frame. Content wiring stays in the runtime. */
export function createModalFrame(
  options: ModalFrameOptions,
  doc: Document = document,
): { overlay: HTMLDivElement; modal: HTMLDivElement } {
  const overlay = doc.createElement('div');
  overlay.className = 'oggi-modal-overlay';
  const modal = doc.createElement('div');
  modal.className = `oggi-modal size-${options.size}`;
  if (options.variant !== 'default') modal.classList.add(`variant-${options.variant}`);
  if (options.theme === 'dark') modal.classList.add('oggi-modal--dark');
  return { overlay, modal };
}
